<div class="not-found-fullscreen" [@fadeIn]>
  <!-- Top-left brand button to go home -->
  <button class="brand-home" (click)="retourAccueil()">
    <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png" alt="Applisound" />
    <span>{{ 'NOT_FOUND.RETURN_HOME' | translate }}</span>
  </button>

  <div class="center-card">
    <img class="splash" src="https://applisound-images.s3.eu-west-3.amazonaws.com/eclats-bleu-404.png" alt="404 splash" />
    <h1>404</h1>
    <h2>{{ 'NOT_FOUND.TITLE' | translate }}</h2>
    <p class="motto">{{ 'NOT_FOUND.MOTTO' | translate }}</p>

    <div class="mini-player">
      <button class="play" (click)="togglePlay()">
        <i class="fas" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
        <span>{{ isPlaying ? ( 'NOT_FOUND.PAUSE' | translate ) : ( 'NOT_FOUND.PLAY' | translate ) }}</span>
      </button>
      <div class="track">
        <span class="title">{{ currentTrack.title }}</span>
        <span class="artist">{{ currentTrack.artist }}</span>
      </div>
    </div>
  </div>
</div>
